import * as React from 'react';

import { Alert, Typography } from 'antd';

const DEVELOPER_HUB_MIGRATION_URL = 'https://ajuda.eduzz.com/como-migrar-minhas-integrações-para-a-developer-hub-';

export default function APIInativationAlert() {
  const today = new Date();
  const inactivationDate = new Date('2026-04-30T23:59:59');

  if (today > inactivationDate) {
    return null;
  }

  return (
    <Alert
      type='warning'
      showIcon
      className='mb-4'
      message='Descontinuaremos esta API em 11/01/2027!'
      description={
        <div className='flex flex-col gap-2'>
          <Typography.Paragraph className='mb-0'>
            Mas calma: você poderá utilizar a Developer Hub como fonte de estrutura para suas novas integrações. Lá você
            encontra:
          </Typography.Paragraph>
          <ul className='mb-0 list-disc pl-5'>
            <li>APIs mais completas, com novos endpoints</li>
            <li>Melhor performance e estabilidade</li>
            <li>Documentação atualizada e centralizada</li>
            <li>Canal no Discord para desenvolvedores</li>
          </ul>
          <Typography.Paragraph className='mb-0'>
            Para garantir a continuidade da sua integração, recomendamos que atualize sua conexão com antecedência.
          </Typography.Paragraph>
          <Typography.Link href={DEVELOPER_HUB_MIGRATION_URL} target='_blank' rel='noopener noreferrer'>
            Ver novas APIs no Developer Hub
          </Typography.Link>
        </div>
      }
    />
  );
}
